import React, { useEffect, useState } from "react";
import { Button, Steps, message, Space, Row } from "antd";
import { SaveButton, ModalComponent, trans } from "@comps/components"
import { makeRequest, makeRequestStateless } from "@utils/helpers";
import { createDataReq, getRelatedDataReq, getCompanyRelatedDataReq } from "../requests";
import { Commons, Const } from "../../constants";
import FilterSelectEmployees from "@mods/common/FilterSelectEmployees";
import { getPreviewReq } from "@mods/common/requests";
import { createSelectList } from '@comps/commonFunctions';
import StepOne from "./CreateStepOne";
import CreatePreview from "./CreatePreview";
import CreateTravelPolicy from "../../travelPolicy/components/CreateTravelPolicy";
import { getAllDataReq as getTravelPolicyDataReq } from "../../travelPolicy/requests";
const langKey = Const["requestPolicyPlanner"].lngKey
const formName = "createCompanyRoaster";

const CreateRequestPolicyPlanner = (props) => {
  //========initial child states===============

  //============================
  const [loader, setLoader] = useState(false);
  const [saveLoader, setSaveLoader] = useState(false);
  const [companyRelatedData, setCompanyRelatedData] = useState([]);
  const [selectedEmployments, setEmployments] = useState([]);
  const [previewEmployment, setPreviewEmployments] = useState([]);
  const [previewData, setPreviewData] = useState([]);
  const [travelPolicies, setTravelPolicies] = useState([])
  const [childComponent, setChildComponent] = useState(null)
  //------------intitial steps state---------
  const [firstStepData, setFirstStepData] = useState(null);
  const [currentStep, setCurrent] = useState(0);

  const [preEmployeesFilter, setPreEmployeesFilter] = useState({})
  const [unSelectedEmployees, setUnSelectedEmployees] = useState([])
  const [selectedEmployees, setSelectedEmployees] = useState([])
  //=======================================
  //=======================================
  useEffect(() => {
    getRemoteData()
    // eslint-disable-next-line
  }, []);
  const getRemoteData = () => {
    makeRequestStateless(getRelatedDataReq, null, ongetRelatedDataReq, null);
    makeRequestStateless(getCompanyRelatedDataReq, null, ongetCompanyRelatedDataReq, null);
  }
  const ongetCompanyRelatedDataReq = (response) => {
    setCompanyRelatedData(response)
  }
  const ongetRelatedDataReq = (response) => {
    setTravelPolicies(createSelectList(response.travel_policies))
  }

  const openTravelPolicyCreator = () => {
    makeRequestStateless(getTravelPolicyDataReq, { page: 1 }, (response) => {
      setChildComponent(
        <CreateTravelPolicy
          onCompleted={ onTravelPolicyCompleted }
          onSuccess={ onTravelPolicySaved }
          allData={ response }
        />
      );
    }, onError);
  }

  const onTravelPolicyCompleted = (data) => {
    setChildComponent(null);

    if (data && data.length !== 0) {
      getRemoteData();
    }
  }

  const onTravelPolicySaved = () => {
    getRemoteData();
  }
  //==============================Save all Data=========================================
  const onSubmit = () => {

    //setSaveLoader(true)
    const obj = { ...firstStepData, company_id: localStorage.getItem('company_id') ? localStorage.getItem('company_id') : 1, employment_ids: selectedEmployments, date: firstStepData.date.format('YYYY-MM-DD') }
    let payload = { request_policy_planner: obj };
    makeRequest(setLoader, createDataReq, payload, onSuccess, onError);
  }

  const onSuccess = (data, res) => {

    setSaveLoader(false)
    if (data.errors !== undefined && data.errors.length > 0) {
      message.error(`${data.errors[0].reason}`);
      return;
    }
    else {
      message.success("Saved successfully");
    }
    props.onCompleted(data.request_policy_planners.data);
    props.onSuccess(data)
  }
  const onError = (err, res) => {

    message.error(res.response.data.message);
  }
  //=================Submit First Step 1==============================================
  const getStepOneData = (data, dates) => {
    setFirstStepData(data);
    if (data.for_all !== undefined && data.for_all) {
      const obj = { ...data, company_id: localStorage.getItem('company_id') ? localStorage.getItem('company_id') : 1, employment_ids: selectedEmployments }
      getPreview(obj)
    }
    else {
      setCurrent(currentStep + 1)
    }
  }
  //=====================On Submit Second Step===========================
  const setSelectedEmploymentsIds = (employments) => {
    setEmployments(employments.employment_ids)
    let empIds = employments.employment_ids;
    const obj = { ...firstStepData, company_id: localStorage.getItem('company_id') ? localStorage.getItem('company_id') : 1, employment_ids: empIds }
    getPreview(obj)
    setCurrent(currentStep + 1)
  }

  const getPreview = (data) => {
    let payload = { moduleName: 'requestPolicyPlanners', request_policy_planner: data };
    makeRequest(setLoader, getPreviewReq, payload, onGetPreview, null);
  }
  const onGetPreview = (response) => {
    if (response) {
      setPreviewData(response.request_policy_planner)
      setPreviewEmployments(response.request_policy_planner.employments)
      if (response.request_policy_planner.for_all !== undefined && response.request_policy_planner.for_all) {
        setCurrent(currentStep + 2)
      }
    }
  }
  const onCancel = () => {
    props.onCompleted(false);
  }
  const onBack = () => {
    setCurrent(currentStep - 1)
  }

  //================================Main Modal Component==================================
  return (
    <ModalComponent top={ 20 } width={ 680 } maskClosable={ false }
      mainTitle={ trans(Commons.create) } subTitle={ <>
        <p style={ { paddingLeft: 75, marginTop: -30 } }>{ trans(`${langKey}.moduleName`) }</p>
        <Steps
          className="steps-style"
          current={ currentStep }
          onChange={ setCurrent }
        >
          <Steps.Step className="steps-step1" style={ { paddingLeft: 50 } } />
          <Steps.Step className="steps-step2" disabled={ firstStepData ? false : true } />
          <Steps.Step className="steps-step3" disabled={ firstStepData ? false : previewEmployment.length > 0 ? false : true } />
        </Steps>
      </> }
      visible={ true } onCancel={ () => props.onCompleted(false) } footer={ '' }>
      { childComponent }

      { currentStep === 0 ?
        <StepOne
          travelPolicies={ travelPolicies }
          initialValues={ firstStepData }
          response={ getStepOneData }
          onCancel={ onCancel }
          onCreateTravelPolicy={ openTravelPolicyCreator }
        />
        : currentStep === 1 ?
          <FilterSelectEmployees setSelectedEmploymentsIds={ setSelectedEmploymentsIds } initialValues={ preEmployeesFilter } companyRelatedData={ companyRelatedData } onCancel={ onCancel } onBack={ onBack }
            employment_ids={ selectedEmployments }
            moduleName='companyRoaster' selected={ selectedEmployees } unSelected={ unSelectedEmployees } preFilters={ preEmployeesFilter } setSelected={ setSelectedEmployees } setUnselected={ setUnSelectedEmployees } setPrefilters={ setPreEmployeesFilter }
          />
          : currentStep === 2 && previewData ?
            <CreatePreview record={ previewData } /> : '' }


      {
        currentStep === 2 ?
          <Row justify="end">
            <Space>
              <Button className="button-back" onClick={ () => setCurrent(currentStep - 1) } disabled={ currentStep > 0 ? false : true }>
                <span style={ { color: "#4079FC" } }>Back</span>
              </Button>
              <SaveButton className="button-next" loading={ saveLoader } form={ formName } key="create_button" onClick={ () => onSubmit() } disabled={ previewData ? false : true } />
            </Space>
          </Row>
          : ''
      }
    </ModalComponent>
  )
}
export default CreateRequestPolicyPlanner
